import { BaseStudy } from '../base-study';
import { BaseEntity } from '../base-entity';

export class CreatePbaPayload {
  name: string;
  study: BaseStudy;
  primaryLegalEntity: BaseEntity;
  method = 1;
  description: string;
}
